import { logging } from "selenium-webdriver";

export class raiseDispute {

    id: number;
    application_id: String;
    phone_no: String;
    email: String;
    reason: String;
    created_by: String = localStorage.getItem('user_id');
    comment: String = "";
    contact_person_name: String;
    status: String = "1";

}